/**
 * Created by piotr.pozniak@thebeaverhead.com on 14/06/2019.
 */

import React, { useCallback } from "react";

import PropTypes from "prop-types";
import { INTEGRATION_NAMES } from "../../../../../consts";
import Accordion from "../../../component/WidgetSettings/Acordion";
import { ucFirst } from "../../../../../helpers/string";
import classNames from "classnames";
import IntegrationSelect from "../../../component/Integration/IntegrationSelect";

const MandatoryInformation = (props) => {
  /**
   *
   * @param fieldName
   * @param callback
   * @returns {function(*=): void}
   */
  const onFormFieldChange = (fieldName) => (e) => {
    props.onUpdateField(fieldName, e.target.value);
  };

  const onFormSubmit = useCallback((e) => {
    e.preventDefault();
  }, []);

  const subtitle =
    props.showSummary &&
    props.calendarModel &&
    props.calendarModel.integration_uuid
      ? `${ucFirst(props.calendarModel.name)} calendar using ${
          INTEGRATION_NAMES[props.calendarModel.integration.type]
        }.`
      : null;

  return (
    <Accordion
      title={"Name & Integration"}
      subtitle={subtitle}
      keepExpanded={props.expanded}
    >
      <form action="#" onSubmit={onFormSubmit}>
        <div className="form-group">
          <div className="col-xs-12">
            <label htmlFor={"calendar_name"} className={""}>
              Widget Name
            </label>
            <input
              type="text"
              className={classNames("form-control", {
                "is-invalid": props.formErrors.nameError,
              })}
              placeholder="Calendar Name"
              id="calendar_name"
              onChange={onFormFieldChange("name")}
              value={props.calendarModel.name || ""}
              disabled={props.disabled}
            />
          </div>
        </div>
        <IntegrationSelect
          disabled={props.disabled}
          error={props.formErrors.integrationError}
          onChange={onFormFieldChange("integration_uuid")}
          selectedIntegrationUUID={props.calendarModel.integration_uuid}
        />
      </form>
    </Accordion>
  );
};

MandatoryInformation.defaultProps = {
  expanded: false,
  showSummary: true,
};

MandatoryInformation.propTypes = {
  calendarModel: PropTypes.object.isRequired,
  onUpdateField: PropTypes.func.isRequired,
  integrations: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  showSummary: PropTypes.bool,
};

export default MandatoryInformation;
